/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GraduatoriaRigaPubblicazioneDTO { 
    posizione?: number;
    sezione?: string;
    codice_pratica?: string;
    punteggio?: number;
    esito?: GraduatoriaRigaPubblicazioneDTOEsitoEnum;
}
export enum GraduatoriaRigaPubblicazioneDTOEsitoEnum {
    RICHIESTA_AMMESSA_FINANZIATA = 'RICHIESTA_AMMESSA_FINANZIATA',
    RICHIESTA_AMMESSA_NON_FINANZIATA = 'RICHIESTA_AMMESSA_NON_FINANZIATA'
};



